import React from "react";
import styles from "../../scss/Logo.module.scss"

const Logo2 = () => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1500 512.52"
      className={styles.logo}
    >
      <defs>
        <style>
          {`.cls-1 {
        fill: #444545;
      }

      .cls-2 {
        fill: #4d4d4f;
      }

      .cls-3 {
        fill: #adb182;
      }`}
        </style>
      </defs>
      <g>
        <path
          class="cls-3"
          d="m344.39,113.13l-27.99,47.6c-1.59,2.29-3.22,4.56-4.89,6.79-4.36,5.86-9.04,11.62-14.9,15.96-11.27,8.35-25.13,9.73-38.15,5.22-5.93-2.06-11.87-4.99-18.05-8.17-5.68-2.68-11.33-5.59-17.5-7.93-12.54-4.98-28.74-5.56-40.02,3.12-14.6,10.76-18.61,30.07-17.38,47.01.65,9.81,3.18,19.63,5.67,28.97,3.09,10.93,6.5,21.74,10.15,32.46,1.57,4.64,3.19,9.27,4.85,13.89.83,2.32,2.61,8.09,4.48,15.12,1.93,7.26,3.12,13.02,4.32,20.54-41.38-11.72-73.6-43.52-81.09-88.57-3.63-21.86-.63-43.35,7.48-62.48,17.98-42.4,60.06-69.52,106.11-69.52h116.9Z"
        />
        <path
          class="cls-3"
          d="m391.4,192.58c-7.25-5.22-15.15-9.6-23.53-13.02-10.09,65.94-22.39,154.81-42.55,187.66-.89,1.41-1.91,2.49-2.99,3.28-.04.03-.08.07-.12.09-1.23.93-2.77,1.48-4.44,1.48-2.14,0-4.08-.92-5.44-2.37l-.02-.02c-.98-.94-1.86-2.16-2.57-3.65-4.19-9.14-6.58-48.17-8.61-57.9-1.54-7.35-4.44-14.48-9.84-19.83-2.58-2.56-5.61-4.59-8.96-5.78-1.65-.48-3.39-.74-5.18-.74-4.93,0-9.85,1.95-13.22,5.59-.16.18-.32.35-.47.53-9.87,11.41-13.4,27.91-16.25,42.28-.96,4.78-1.73,9.61-2.33,14.46h0s-4.17,31.66-13.88,41.37c-9.71,9.71-27.44,14.12-27.44,14.12h120.08c62.92,0,115.57-51.48,115.62-114.42.03-38.33-18.88-72.33-47.86-93.14Z"
        />
      </g>
      <g>
        <path
          class="cls-3"
          d="m552.34,364.56c-1.46,3.24-4.29,5.12-7.77,5.12-4.77,0-8.41-3.82-8.41-8.78s3.6-8.74,8.41-8.74c3.46,0,6.39,1.86,7.81,4.94h5.42c-1.48-6.13-6.63-10.17-13.23-10.17-7.97,0-14,5.99-14,13.96s6.03,14.02,14,14.02c6.59,0,11.83-4.13,13.31-10.36h-5.54Z"
        />
        <path class="cls-3" d="m573.56,340.76v33.51h5.5v-33.51h-5.5Z" />
        <path
          class="cls-3"
          d="m597.16,347.57v26.7h5.48v-26.7h-5.48Zm5.58-6.8v4.65h-5.68v-4.65h5.68Z"
        />
        <path
          class="cls-3"
          d="m634.88,346.97c-3.94,0-7.22,1.64-9.24,4.33l-1.07-3.74h-3.84v26.7h5.5v-14.3c0-4.71,2.97-8.07,7.16-8.07s6.13,2.57,6.13,7.42v14.95h5.48v-16.08c0-6.57-3.9-11.21-10.13-11.21Z"
        />
        <path
          class="cls-3"
          d="m662.69,340.76v4.65h5.66v-4.65h-5.66Zm.08,6.8v26.7h5.5v-26.7h-5.5Z"
        />
        <path
          class="cls-3"
          d="m706.16,364.56c-1.44,3.24-4.27,5.12-7.77,5.12-4.75,0-8.41-3.82-8.41-8.78s3.6-8.74,8.41-8.74c3.48,0,6.41,1.86,7.81,4.94h5.44c-1.48-6.13-6.65-10.17-13.23-10.17-7.99,0-14,5.99-14,13.96s6.03,14.02,13.98,14.02c6.59,0,11.85-4.13,13.31-10.36h-5.54Z"
        />
        <path
          class="cls-3"
          d="m742.24,340.76c-.55.3-1.21.43-1.96.43s-1.4-.14-1.98-.43h-5.46c1.27,2.57,3.94,4.07,7.44,4.07s6.17-1.5,7.42-4.07h-5.46Zm7.5,6.8l-.63,3.32c-2.43-2.47-5.83-3.96-9.77-3.96-7.95,0-13.89,5.95-13.89,13.98s5.93,14,13.89,14c3.9,0,7.26-1.46,9.69-3.92l.53,3.24h4.43v-26.68h-4.25Zm-9.97,22.09c-5.02,0-8.74-3.76-8.74-8.74s3.72-8.76,8.74-8.76,8.7,3.72,8.7,8.76-3.66,8.74-8.7,8.74Z"
        />
        <path
          class="cls-3"
          d="m810.5,358.17c-3.22-.53-5.93-.99-5.93-3.36,0-1.94,1.86-3.22,4.91-3.22,3.22,0,5.16,1.36,5.26,3.9h5.2c-.12-5.18-4.13-8.55-10.34-8.55s-10.34,3.26-10.34,8.05c0,6.19,5.24,7.2,9.69,7.97,3.26.55,6.13,1.13,6.13,3.66,0,2.23-2.27,3.48-5.22,3.48-3.2,0-5.58-1.48-5.72-4.29h-5.36c.14,5.54,4.41,9.12,10.9,9.12s10.82-3.36,10.82-8.54c0-6.59-5.48-7.46-9.99-8.21Z"
        />
        <path
          class="cls-3"
          d="m848.34,369.28c-3.24,0-5-1.78-5-4.94v-12.07h7.89v-4.71h-7.93v-6.23h-.95l-9.28,9.87v1.07h4.77v12.48c0,5.91,3.62,9.51,9.47,9.51h4.07v-4.98h-3.05Z"
        />
        <path
          class="cls-3"
          d="m879.02,346.93c-8.17,0-14.28,5.91-14.28,13.98s6.11,14,14.28,14,14.26-5.97,14.26-14-6.11-13.98-14.26-13.98Zm0,22.75c-5.06,0-8.68-3.64-8.68-8.76s3.62-8.76,8.68-8.76,8.68,3.66,8.68,8.76-3.64,8.76-8.68,8.76Z"
        />
        <path
          class="cls-3"
          d="m939.26,346.97c-3.52,0-6.76,1.8-8.7,4.67-1.52-2.89-4.39-4.67-8.01-4.67-3.24,0-6.29,1.54-8.29,4.06l-.95-3.46h-3.9v26.7h5.5v-14.6c0-4.55,2.73-7.77,6.29-7.77,3.34,0,5.2,2.45,5.2,6.75v15.63h5.36v-14.6c0-4.55,2.71-7.77,6.25-7.77,3.32,0,5.2,2.45,5.2,6.75v15.63h5.48v-16.97c0-6.05-3.8-10.33-9.43-10.33Z"
        />
        <path
          class="cls-3"
          d="m988.77,347.57l-.63,3.32c-2.43-2.47-5.84-3.96-9.77-3.96-7.95,0-13.89,5.95-13.89,13.98s5.93,14,13.89,14c3.9,0,7.28-1.46,9.69-3.92l.53,3.24h4.41v-26.68h-4.23Zm-9.97,22.09c-5.02,0-8.74-3.76-8.74-8.74s3.72-8.76,8.74-8.76,8.7,3.72,8.7,8.76-3.66,8.74-8.7,8.74Z"
        />
        <path
          class="cls-3"
          d="m1023.03,369.28c-3.22,0-5-1.78-5-4.94v-12.07h7.91v-4.71h-7.95v-6.23h-.93l-9.3,9.87v1.07h4.79v12.48c0,5.91,3.6,9.51,9.46,9.51h4.07v-4.98h-3.05Z"
        />
        <path
          class="cls-3"
          d="m1053.71,346.93c-8.17,0-14.26,5.91-14.26,13.98s6.09,14,14.26,14,14.28-5.97,14.28-14-6.13-13.98-14.28-13.98Zm0,22.75c-5.04,0-8.68-3.64-8.68-8.76s3.64-8.76,8.68-8.76,8.68,3.66,8.68,8.76-3.62,8.76-8.68,8.76Z"
        />
        <path class="cls-3" d="m1084.13,340.76v33.51h5.48v-33.51h-5.48Z" />
        <path
          class="cls-3"
          d="m1120.03,346.93c-8.17,0-14.28,5.91-14.28,13.98s6.11,14,14.28,14,14.26-5.97,14.26-14-6.11-13.98-14.26-13.98Zm0,22.75c-5.06,0-8.7-3.64-8.7-8.76s3.64-8.76,8.7-8.76,8.68,3.66,8.68,8.76-3.64,8.76-8.68,8.76Z"
        />
        <path
          class="cls-3"
          d="m1172.28,347.57l-.89,3.44c-2.39-2.53-5.82-4.07-9.73-4.07-7.44,0-13.19,5.84-13.19,13.29s5.76,13.25,13.19,13.25c3.46,0,6.53-1.19,8.84-3.19v1.23c0,5.06-3.38,8.11-7.99,8.11-3.38,0-6.51-1.62-7.54-4.55h-5.48c1.36,5.85,6.21,9.42,13.05,9.42,8.25,0,13.33-5.2,13.33-13.73v-23.2h-3.6Zm-10.01,20.83c-4.75,0-8.23-3.5-8.23-8.17s3.48-8.19,8.23-8.19,8.21,3.46,8.21,8.19-3.44,8.17-8.21,8.17Z"
        />
        <path
          class="cls-3"
          d="m1194,347.57v26.7h5.48v-26.7h-5.48Zm5.58-6.8v4.65h-5.68v-4.65h5.68Z"
        />
        <path
          class="cls-3"
          d="m1237.38,364.56c-1.44,3.24-4.27,5.12-7.77,5.12-4.75,0-8.41-3.82-8.41-8.78s3.6-8.74,8.41-8.74c3.48,0,6.41,1.86,7.81,4.94h5.44c-1.48-6.13-6.63-10.17-13.23-10.17-7.97,0-14,5.99-14,13.96s6.03,14.02,13.98,14.02c6.61,0,11.85-4.13,13.31-10.36h-5.54Z"
        />
        <path
          class="cls-3"
          d="m1273.46,340.76c-.55.3-1.21.43-1.96.43s-1.4-.14-1.98-.43h-5.44c1.25,2.57,3.92,4.07,7.42,4.07s6.17-1.5,7.44-4.07h-5.48Zm7.52,6.8l-.65,3.32c-2.41-2.47-5.82-3.96-9.75-3.96-7.95,0-13.91,5.95-13.91,13.98s5.95,14,13.91,14c3.88,0,7.26-1.46,9.67-3.92l.53,3.24h4.43v-26.68h-4.23Zm-9.99,22.09c-5.02,0-8.74-3.76-8.74-8.74s3.72-8.76,8.74-8.76,8.72,3.72,8.72,8.76-3.68,8.74-8.72,8.74Z"
        />
      </g>
      <g>
        <path
          class="cls-1"
          d="m744.39,243.04c4.35-1.9,8.76-5.02,13.2-9.3,5.38-5.05,9.47-11.35,12.3-18.85,2.84-7.5,4.25-14.93,4.25-22.3,0-8.27-1.75-16.04-5.27-23.32-3.54-7.28-8.5-13.45-14.95-18.51-6.12-4.74-12.76-7.86-19.88-9.3-7.11-1.46-14.51-2.19-22.18-2.19h-52.63v29.65h52.41c3.98,0,7.81.54,11.5,1.62,3.67,1.07,6.92,2.69,9.76,4.83,2.82,2.14,5.09,4.86,6.77,8.15,1.68,3.3,2.53,7.16,2.53,11.62s-.8,8.54-2.42,11.84c-1.6,3.28-3.79,6-6.55,8.15-2.75,2.16-6,3.76-9.76,4.83-3.76,1.07-7.7,1.62-11.84,1.62h-36.55l62.07,89.86h38.61l-46.66-63.43c5.82-1.39,10.92-3.03,15.29-4.95Z"
        />
        <polygon
          class="cls-1"
          points="788.61 169.01 829.8 169.01 829.8 311.19 859.79 311.19 859.79 169.01 900.99 169.01 900.99 139.03 788.61 139.03 788.61 169.01"
        />
        <polygon
          class="cls-1"
          points="1308.1 139.03 1308.1 177.25 1308.02 177.25 1308.02 311.19 1338 311.19 1338 169.01 1387.62 169.01 1387.62 139.03 1308.1 139.03"
        />
        <path
          class="cls-1"
          d="m1023.13,189.71c-2.38-5.75-5.32-11.23-8.85-16.43-3.52-5.2-7.59-9.88-12.18-14.02-4.76-4.13-9.97-7.47-15.63-10-5.68-2.53-11.6-4.56-17.81-6.09-6.21-1.53-12.5-2.57-18.85-3.11-.75-.05-1.53-.25-3.71-.48-2.13-.2-5.61-.44-11.79-.56h0c-2.28-.05-4.95-.08-8.05-.1v.1h-8.3v29.99h8.3v.12c20.41-.1,24.51,1.48,27.55,2.08,4.75.92,9.34,2.35,13.8,4.25,4.44,1.92,8.66,4.64,12.64,8.16,5.97,5.36,10.58,11.8,13.8,19.31,3.21,7.52,4.83,15.26,4.83,23.22,0,4.75-.58,9.46-1.73,14.13-1.14,4.68-2.79,9.08-4.93,13.22-2.16,4.13-4.87,7.93-8.16,11.38-3.3,3.44-7.01,6.31-11.14,8.61-7.06,3.84-13.88,6.17-20.46,7.02-6.58.83-13.71,1.26-21.38,1.26h-13.1v29.89h14.02c9.51,0,19.36-.73,29.55-2.19,10.19-1.45,19.42-4.47,27.69-9.08,6.58-3.67,12.45-8.23,17.59-13.68,5.12-5.43,9.42-11.41,12.86-17.93,3.45-6.5,6.09-13.4,7.94-20.68,1.84-7.26,2.76-14.59,2.76-21.94,0-6.12-.61-12.3-1.84-18.51-1.24-6.21-3.03-12.18-5.41-17.93Z"
        />
        <polygon
          class="cls-1"
          points="1047.48 311.64 1160.35 311.64 1160.35 281.76 1079.42 281.76 1079.42 281.66 1077.47 281.66 1077.47 240.9 1137.77 240.9 1137.77 210.9 1077.47 210.9 1077.47 169.02 1160.35 169.02 1160.35 139.03 1047.48 139.03 1047.48 311.64"
        />
        <polygon
          class="cls-3"
          points="1291.4 138.92 1261.39 138.92 1261.39 162.95 1291.4 206.02 1291.4 138.92"
        />
        <polygon
          class="cls-2"
          points="1291.4 311.53 1291.77 311.53 1291.4 310.99 1291.4 311.53"
        />
        <polygon
          class="cls-1"
          points="1288.13 253.84 1208.07 138.92 1208.05 138.92 1187.23 138.92 1187.13 138.92 1178.17 138.92 1178.17 311.53 1208.15 311.53 1208.15 191.53 1231.78 225.45 1291.4 310.99 1291.4 258.53 1288.13 253.84"
        />
        <polygon
          class="cls-1"
          points="613.89 139.38 533.83 254.3 530.56 258.99 530.56 311.45 590.18 225.91 613.81 191.99 613.81 311.99 643.8 311.99 643.8 139.38 613.91 139.38 613.89 139.38"
        />
      </g>
    </svg>
  );
};

export default Logo2;
